import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { canUseMemo, getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { CapsuleInput } from '@/investigate/customCondition/CapsuleInput.molecule';
import { Button } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { Capsule } from '@/utilities/datetime.constants';

export interface CapsuleInputIF extends ValidatingFormComponent<Capsule> {
  component: 'CapsuleInputFormComponent';
  trackCategory: string;
  trackAction: string;
  capsuleWindow?: Capsule;
  setCapsuleInputValidStatus?: (status: boolean) => void;
  disabled?: boolean;
  onRefreshButtonClick?: () => void;
}

const CapsuleInputFormComponentUnwrapped = (props: CapsuleInputIF) => {
  const {
    name,
    validation,
    extendValidation,
    disabled,
    extraClassNames,
    wrapperClassNames,
    testId,
    label,
    onRefreshButtonClick,
  } = props;

  const { t } = useTranslation();
  const defaultValidation = (value: Capsule | undefined) => _.isEmpty(value);
  const formState = useForm().getState();

  const elementLabel = onRefreshButtonClick ? (
    <div className="flexColumnContainer flexSpaceBetween tw:mb-1">
      <div>{t(label as string)}</div>
      <Button
        icon="fa-refresh"
        size="xs"
        label={t('REFRESH')}
        tooltip={t('REFRESH_WINDOW_TOOLTIP')}
        onClick={() => onRefreshButtonClick()}
      />
    </div>
  ) : (
    label
  );

  return (
    <div className={clsx(onRefreshButtonClick && 'width-100percent flexRowContainer flexSpaceBetween')}>
      <FormFieldWrapper
        testId={testId}
        label={elementLabel}
        extraClassNames={extraClassNames}
        wrapperClassNames={wrapperClassNames}>
        <Field<Capsule> name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
          {({ input, meta }) => (
            <div id="specTrainingWindow">
              <CapsuleInput
                {...getFormFieldProps(formState, input, meta, props)}
                isDisabled={disabled}
                appendToBody={true}
                autoUpdateDate={false}
              />
            </div>
          )}
        </Field>
      </FormFieldWrapper>
    </div>
  );
};

export const CapsuleInputFormComponent = React.memo(CapsuleInputFormComponentUnwrapped, canUseMemo);
